var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.125C15.5 0.515625 15.9688 0 16.625 0H21.875C22.4844 0 23 0.515625 23 1.125V6.375C23 7.03125 22.4844 7.5 21.875 7.5C21.2188 7.5 20.75 7.03125 20.75 6.375V3.84375L14.7969 9.79688C14.375 10.2188 13.7188 10.2656 13.25 9.89062L8.75 6L3.82812 10.2656C3.35938 10.6406 2.65625 10.5938 2.23438 10.125C1.85938 9.65625 1.90625 8.95312 2.375 8.53125L8 3.65625C8.42188 3.32812 9.03125 3.32812 9.45312 3.65625L13.9062 7.5L19.1562 2.25H16.625C15.9688 2.25 15.5 1.78125 15.5 1.125ZM5.32812 14.25C5.14062 15.6094 4.0625 16.6875 2.75 16.875V19.1719C4.0625 19.3594 5.14062 20.3906 5.32812 21.75H19.625C19.8125 20.4375 20.8906 19.3594 22.25 19.1719V16.875C20.8906 16.6875 19.8125 15.6094 19.625 14.25H5.32812ZM2.75 12H22.25C23.4688 12 24.5 13.0312 24.5 14.25V21.75C24.5 23.0156 23.4688 24 22.25 24H2.75C1.48438 24 0.5 23.0156 0.5 21.75V14.25C0.5 13.0312 1.48438 12 2.75 12ZM12.5 21C11.4219 21 10.4375 20.4375 9.875 19.5C9.35938 18.6094 9.35938 17.4375 9.875 16.5C10.4375 15.6094 11.4219 15 12.5 15C13.5312 15 14.5156 15.6094 15.0781 16.5C15.5938 17.4375 15.5938 18.6094 15.0781 19.5C14.5156 20.4375 13.5312 21 12.5 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/_growth.95c3d00b9326ec70a541ea6d97cb5d34.svg";
export { ForwardRef as ReactComponent };